export const UPCOMING_BOOKING_DETAILS_START = "UPCOMING_BOOKING_DETAILS_START"
export const UPCOMING_BOOKING_DETAILS_SUCCESS = "UPCOMING_BOOKING_DETAILS_SUCCESS"
export const UPCOMING_BOOKING_DETAILS_ERROR = "UPCOMING_BOOKING_DETAILS_ERROR"

export const ONGOING_BOOKING_DETAILS_START = "ONGOING_BOOKING_DETAILS_START"
export const ONGOING_BOOKING_DETAILS_SUCCESS = "ONGOING_BOOKING_DETAILS_SUCCESS"
export const ONGOING_BOOKING_DETAILS_ERROR = "ONGOING_BOOKING_DETAILS_ERROR"

export const COMPLETED_BOOKING_DETAILS_START = "COMPLETED_BOOKING_DETAILS_START"
export const COMPLETED_BOOKING_DETAILS_SUCCESS = "COMPLETED_BOOKING_DETAILS_SUCCESS"
export const COMPLETED_BOOKING_DETAILS_ERROR = "COMPLETED_BOOKING_DETAILS_ERROR"

export const CANCELLED_BOOKING_DETAILS_START = "CANCELLED_BOOKING_DETAILS_START"
export const CANCELLED_BOOKING_DETAILS_SUCCESS = "CANCELLED_BOOKING_DETAILS_SUCCESS"
export const CANCELLED_BOOKING_DETAILS_ERROR = "CANCELLED_BOOKING_DETAILS_ERROR"

export const BOOKING_SUMMARY_DETAILS_START = "BOOKING_SUMMARY_DETAILS_START"
export const BOOKING_SUMMARY_DETAILS_SUCCESS = "BOOKING_SUMMARY_DETAILS_SUCCESS"
export const BOOKING_SUMMARY_DETAILS_ERROR = "BOOKING_SUMMARY_DETAILS_ERROR"
